import axios from 'axios';

export default class SingleConfigActions {
  constructor(resource, publicUrl, customConfig) {
    this.publicUrl = publicUrl;
    this.resource = resource;
    this.customConfig = customConfig;
  }

  getSplitItemsByWorkOrder() {
    return axios.get(
      `${this.publicUrl}${this.resource}/splititemsbyworkorder`,
      this.customConfig
    );
  }

  getCurrency() {
    return axios.get(
      `${this.publicUrl}${this.resource}/currency`,
      this.customConfig
    );
  }
}
